import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const DomainIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="building" {...props} />;
};

export { DomainIcon };
